export const images = {
  anagogLogo: "https://storage.googleapis.com/hello-static-assets/signup/anagog-logo.png",
  apesterLogo: "https://storage.googleapis.com/hello-static-assets/signup/apester-logo.png",
  buildingTestDrive: "https://storage.googleapis.com/hello-static-assets/signup/building-test-drive-min.png",
  exabeamLogo: "https://storage.googleapis.com/hello-static-assets/signup/exabeam-logo.png",
  siftLogo: "https://storage.googleapis.com/hello-static-assets/signup/sift-logo.png",
  zoominfoLogo: "https://storage.googleapis.com/hello-static-assets/signup/zoominfo-logo.png",
  doitLogo: "https://storage.googleapis.com/hello-static-assets/signup/logo-official.png",
};
